var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-color": "basic",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C7 4.44772 7.44772 4 8 4H16C16.5523 4 17 4.44772 17 5V18C17 18.3858 16.7781 18.7371 16.4298 18.9029C16.0814 19.0687 15.6688 19.0194 15.3694 18.7761L12 16.0385L8.63059 18.7761C8.33119 19.0194 7.91856 19.0687 7.57023 18.9029C7.2219 18.7371 7 18.3858 7 18V5ZM9 6V15.899L11.3694 13.9739C11.7368 13.6754 12.2632 13.6754 12.6306 13.9739L15 15.899V6H9Z",
    fill: "#5A5859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcn);
export default __webpack_public_path__ + "static/media/bookmark-icn.723325aca59d356c8f4afbf644de47f4.svg";
export { ForwardRef as ReactComponent };